export default "__VITE_ASSET__CZDOc3iW__"